'use strict';

var templates = require('../templates');
var fobclient = require('..');
var Ansprechpartner = require('../entity').Ansprechpartner;

module.exports = function (connection) {
  return {
    byLandAnsprechpartnerEquals: function byLandAnsprechpartnerEquals(landansprechpartner, additionalParams) {
      return templates.searchTemplate(connection)(Ansprechpartner, 'byLandAnsprechpartnerEquals', 'landansprechpartner')(landansprechpartner, additionalParams);
    },
    byLandAnsprechpartnerLike: function byLandAnsprechpartnerLike(landansprechpartner, additionalParams) {
      return templates.searchTemplate(connection)(Ansprechpartner, 'byLandAnsprechpartnerLike', 'landansprechpartner')(landansprechpartner, additionalParams);
    },
    byNameAnsprechpartnerEquals: function byNameAnsprechpartnerEquals(nameansprechpartner, additionalParams) {
      return templates.searchTemplate(connection)(Ansprechpartner, 'byNameAnsprechpartnerEquals', 'nameansprechpartner')(nameansprechpartner, additionalParams);
    },
    byNameAnsprechpartnerLike: function byNameAnsprechpartnerLike(nameansprechpartner, additionalParams) {
      return templates.searchTemplate(connection)(Ansprechpartner, 'byNameAnsprechpartnerLike', 'nameansprechpartner')(nameansprechpartner, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(Ansprechpartner, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(Ansprechpartner, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('ansprechpartner')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/ansprechpartner.js
// module id = cMYb
// module chunks = 0